import { createTheme } from '@material-ui/core/styles';
import theme from './theme';

const styles = {
  palette: {
    primary: theme.colors.actions.primary,
    secondary: theme.colors.actions.secondary,
    error: {
      light: theme.colors.error[0],
      main: theme.colors.error[2],
    },
  },
  shape: {
    borderRadius: theme.radii,
  },
  spacing: theme.spacing,
  typography: {
    fontFamily: theme.fonts.body,
    button: {
      fontSize: `${theme.fontSizes[0]}px`,
      fontWeight: theme.fontWeights[6],
      letterSpacing: '1',
      textTransform: 'uppercase',
    },
  },
  props: {
    MuiInputBase: {
      className: 'input-base',
    },
    MuiButton: {
      variant: 'contained',
    },
    MuiTextField: {
      variant: 'outlined',
    },
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: 'transparent',
      },
    },
    MuiButton: {
      root: {
        color: theme.colors.actions.default.main,
      },
      containedPrimary: {
        backgroundColor: theme.colors.actions.primaryButton.main,
        color: theme.colors.actions.primaryButton.contrastText,
        '&&:hover': {
          backgroundColor: theme.colors.actions.primaryButton.dark,
        },
      },
      textSecondary: {
        color: theme.colors.actions.secondaryTextButton.main,
      },
      contained: {
        backgroundColor: theme.colors.actions.default.main,
        color: theme.colors.actions.default.contrastText,
        '&:hover': {
          backgroundColor: theme.colors.actions.default.dark,
        },
      },
    },
    MuiIconButton: {
      colorSecondary: {
        color: theme.colors.actions.default.main,
      },
    },
    MuiCard: {
      root: {
        color: theme.colors.text[2],
      },
    },
    MuiCardHeader: {
      title: {
        color: theme.colors.text[3],
        fontWeight: theme.fontWeights[6],
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '0',
        paddingTop: `${theme.space[2]}px`,
        paddingBottom: `${theme.space[2]}px`,
      },
    },
    MuiCheckbox: {
      root: {
        padding: `${theme.space[2]}px`,
      },
    },
    MuiFormLabel: {
      root: {
        marginBottom: `${theme.space[2]}px`,
        color: theme.colors.text[3],
        '&$focused': {
          color: theme.colors.text[3],
        },
      },
      focused: {},
    },
    MuiInputLabel: {
      root: {
        color: theme.colors.text[2],
        fontSize: '1.125rem',
      },
    },
    MuiListItem: {
      root: {
        '&&:hover': {
          backgroundColor: theme.colors.neutrals[2],
        },
        '&$selected': {
          backgroundColor: theme.colors.neutrals[0],
        },
      },
    },
    MuiMenuItem: {
      root: {
        '&&:hover': {
          backgroundColor: theme.colors.neutrals[2],
        },
      },
    },
    MuiInputAdornment: {
      root: {
        color: theme.colors.actions.primary.main,
      },
    },
  },
};

export default createTheme(styles);
